/**
 * Register block single property.
 */
import { edit } from "./edit";
import metadata from "./block.json";

export const settings = {
    ...metadata,
    edit
}
